import { AreasConfig } from "types/Farm.js"
import { COMPONENTS } from "./create.js"



export function buildRuuvi(): AreasConfig {
	return {
		code: COMPONENTS.HVAC,
		growUnits: [
			{
				tags: ["sensor_avr"],
				code: COMPONENTS.CMP_1,
				areas: [
					{ name: "tower.A.2", aliases: [null, "3828"] },
					{ name: "tower.A.1.end", aliases: ["8402"] },
					{ name: "tower.B.1", aliases: [null, "8402"] },
				]
			},
			{
				tags: ["sensor_avr"],
				code: COMPONENTS.CMP_2,
				areas: [
					{ name: "tower.A.1.start", aliases: ["D73C", null, null, "02A2"] },
					{ name: "tower.B.1", aliases: [null, "287E"] },
					{ name: "tower.B.1.end", aliases: [null, "B6D1"] },
					{ name: "tower.B.2.end", aliases: [null, "55CE", "F109"] },
					{ name: "tower.E.1.end", aliases: [null, null, null, "673C"] },
					{ name: "tower.F.1.start", aliases: [null, "1706"] },
					{ name: "tower.F.2.end", aliases: ["E484", null, "ACA7"] },
				]
			},
			{
				tags: ["sensor_avr"],
				code: COMPONENTS.CMP_3,
				areas: [
					{ name: "tower.A.1.end", aliases: [null,"92D6"] },
					{ name: "tower.A.1.start", aliases: ["D8F0"] },
					{ name: "tower.B.1.end", aliases: [null, "D8F0"] },
					{ name: "tower.C.1.end", aliases: [null, "D8F0"] },
					{ name: "tower.D.1.start", aliases: ["1212"] },
				]
			},
			{
				tags: ["sensor_avr"],
				code: COMPONENTS.CMP_4,
				areas: [
					{ name: "tower.A.2.end", aliases: ["400D"] },

					{ name: "tower.B.1.end", aliases: [null, "C82A", null, "4556"] },

					{ name: "tower.C.2.end", aliases: ["06D8"] },

					{ name: "tower.D.1.start", aliases: [null, "9063", null, null, "2703"] },
					{ name: "tower.D.2", aliases: ["4E91"] },
					{ name: "tower.D.2.end", aliases: ["11C2"] },

					{ name: "tower.E.2.end", aliases: ["3738"] },
					{ name: "tower.E.1.end", aliases: [null, null, "0D07"] },
					{ name: "tower.E.1.start", aliases: [null, null, null, "5EC9"] },

					{ name: "tower.F.2.end", aliases: [null, null,"B988"] },
				]
			},
			{
				tags: ["sensor_avr"],
				code: COMPONENTS.CMP_5,
				areas: [
					{ name: "tower.A.1", aliases: ["481D"] },
					{ name: "tower.B.1", aliases: [null, null, "4222"] },
					{ name: "tower.E.2", aliases: ["96E0"] },
					{ name: "tower.E.2.end", aliases: [null, ["7895", "4B90"], "D27E"] },
					{ name: "tower.E.1.start", aliases: ["2AB6"] },
					{ name: "tower.E.1", aliases: [null, "DBC9"] },
				]
			},
		],
		areas: [
			{ name: "office", aliases: ["5F8C"] },
			{ name: "seeding", aliases: ["95D4"] },
			{ name: "packaging_enter_left", aliases: ["CD20"] },
			{ name: "packaging_tablets", aliases: ["D873"] },
		],
	}
}